export default function assertExhaustiveSwitch(arg: never): never {
  throw new Error(
    `Value ${arg as string} was not accounted for in expected exhaustive switch statement.`,
  );
}
